module.exports = __webpack_public_path__ + "static/media/i2.b856e753.svg";